export enum IntegrationBridgeType {

    DUMMY = 1,
    HTML5 = 2,
    REACT_NATIVE = 3,
}
